import { ProductModelInstance } from 'src/store/_models/product';

export const getSelectedLookupOption = (product: ProductModelInstance, lookup_code: string) => {
  return product.lookups.find(lookup => lookup.code === lookup_code)?.options?.find(option => option.selected);
};
